import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FooterModule } from '@shared/components/footer/footer.module';
import { SvgModule } from '@shared/components/svg/svg.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HoverableSvgModule } from '@shared/components/hoverable-svg/hoverable-svg.module';
import { LoaderModule } from '@shared/components/loader/loader.module';
import { DevelopersRoutingModule } from './developers-routing.module';
import { DevelopersMainComponent } from './components/main/developers-main.component';
import { MainModule } from '../main/main.module';
import { CardComponent } from './components/card/card.component';

@NgModule({
  declarations: [DevelopersMainComponent, CardComponent],
  imports: [
    CommonModule,
    DevelopersRoutingModule,
    MatIconModule,
    MainModule,
    SvgModule,
    FooterModule,
    TranslateModule,
    NgLetModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    HoverableSvgModule,
    LoaderModule
  ]
})
export class DevelopersModule {}
